<template>
  <div ref="test" v-loading="loading" class="test">
    <ul class="test__progress">
      <span v-for="(_, index) in questions" :key="index">
        <li
          :class="[
            'test__progress-item',
            {
              'test__progress-item--active': index === selectedQuestionIndex || index <= selectedQuestionIndex,
            },
          ]"
        >
          {{ index + 1 }}
        </li>
      </span>
    </ul>
    <div class="test__container">
      <div class="question">
        <div class="question__info">
          <h1 class="question__info-text text-uppercase">
            {{ $t('testTest.doubleClickCorrect') }}
          </h1>
          <transition name="fade">
            <span v-if="countDownTimerStatus" class="question__info-time">{{ timePerQuestion | secondsToTime }}</span>
          </transition>
        </div>
        <div v-if="questions.length" class="py-2 px-1">
          <template v-if="renderQuestion">
            <h3 class="question__text">{{ questions[selectedQuestionIndex].text }}</h3>
            <h2 class="question__example">{{ questions[selectedQuestionIndex].example }}</h2>
          </template>
          <template v-if="questions[selectedQuestionIndex].type === 'M'">
            <ul class="question__multiple-choices">
              <template v-for="option in questions[selectedQuestionIndex].options">
                <li v-if="option" :key="option" class="question__multiple-choices-item">
                  <button
                    :class="[
                      'btn',
                      'question__multiple-choices-item-button',
                      { 'question__multiple-choices-item-button--active': userAnswer === option },
                    ]"
                    @click="userAnswer = option"
                  >
                    {{ option }}
                  </button>
                </li>
              </template>
            </ul>
          </template>
          <template v-if="questions[selectedQuestionIndex].type === 'B'">
            <ul class="question__two-choices">
              <template v-for="option in questions[selectedQuestionIndex].options">
                <li v-if="option" :key="option" class="question__two-choices-item">
                  <button
                    :class="[
                      'btn',
                      'question__two-choices-item-button',
                      { 'question__two-choices-item-button--active': userAnswer === option },
                    ]"
                    @click="userAnswer = option"
                  >
                    {{ option }}
                  </button>
                </li>
              </template>
            </ul>
          </template>
          <template v-if="questions[selectedQuestionIndex].type === 'T'">
            <div class="question__write-answer">
              <input v-model="userAnswer" type="text" class="question__write-answer-input form-control" />
            </div>
          </template>
        </div>
        <div class="question__actions">
          <button class="btn btn-skip" :disabled="userAnswer" @click="skipQuestion">
            {{ $t('testTest.skip') }}
          </button>
          <button class="btn btn-submit" :disabled="!userAnswer" @click="handleUserAnswer">
            {{ $t('testTest.submit') }}
          </button>
        </div>
      </div>
    </div>
    <button
      type="button"
      class="btn btn-exit"
      @click="
        $router.push({
          name: 'subject',
          params: { grade_id: $route.params.grade_id, subject_id: $route.params.subject_id },
          query: { cluster_id: $route.params.cluster_id },
        })
      "
    >
      <img src="@/assets/img/close.png" alt />
      {{ $t('pretest.exit') }}
    </button>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import moment from 'moment';

export default {
  name: 'Test',
  filters: {
    OnlyQuestion: value => {
      let response;
      if (value.indexOf('?') > -1) {
        response = value.split('?');
        return `${response[0]}?`;
      }
      if (value.indexOf('"') > -1) {
        response = value.split('"');
        return response[0];
      }
      if (value.indexOf('.') > -1) {
        response = value.split('.');
        return response[0];
      }
      return value;
    },
    OnlyExample: value => {
      let response;
      if (value.indexOf('?') > -1) {
        response = value.split('?');
      }
      if (value.indexOf('"') > -1) {
        response = value.split('"');
      }
      if (value.indexOf('.') > -1) {
        response = value.split('.');
      }
      return response[1];
    },
  },
  data() {
    return {
      countDownTimerStatus: true,
      renderQuestion: true,
      timeoutId: null,
      questions: [],
      selectedQuestionIndex: 0,
      secondsPerQuestion: 0,
      timePerQuestion: 180,
      loading: false,
      userAnswer: null,
      skipped: false,
      test: {
        questionsCorrect: 0,
        wrongQuestions: 0,
        skippedQuestions: 0,
        average: 0,
        startedDate: null,
        finishDate: null,
        clusterId: Number.parseInt(this.$route.params.cluster_id),
        questions: [],
      },
    };
  },
  computed: {
    ...mapGetters({
      currentSubject: 'subject/currentSubject',
      authenticatedUser: 'auth/authenticatedUser',
      // currentCluster: 'cluster/currentCluster',
    }),
  },
  watch: {
    selectedQuestionIndex(newIndex) {
      console.log(this.questions[newIndex].answer_correct);
    },
  },
  created() {
    this.fetchQuestions();
    this.test.startedDate = moment().format();

    // if (Object.keys(this.currentCluster).length === 0) {
    //   const index = this.clusters.findIndex(cluster => cluster.id === Number.parseInt(clusterId));
    //   this.$store.commit('cluster/SET_CURRENT_CLUSTER', index);
    // }
    window.onbeforeunload = function (event) {
      console.log(event);
      return confirm('Confirm refresh');
    };
  },
  destroyed() {
    clearTimeout(this.timeoutId);
  },
  methods: {
    countDownTimer() {
      clearTimeout(this.timeoutId);
      if (this.timePerQuestion > 0) {
        this.timeoutId = setTimeout(() => {
          this.timePerQuestion -= 1;
          this.countDownTimer();
          this.countDownTimerStatus = false;
          setTimeout(() => {
            this.countDownTimerStatus = true;
          }, 100);
        }, 1000);
      } else {
        this.handleUserAnswer();
      }
    },
    handleUserAnswer() {
      let answerCorrect = this.questions[this.selectedQuestionIndex].answer_correct;
      const questionType = this.questions[this.selectedQuestionIndex].type;

      if (this.questions[this.selectedQuestionIndex].type === 'T') {
        answerCorrect = this.questions[this.selectedQuestionIndex].answer_correct.toLowerCase();
        this.userAnswer = this.userAnswer.toLowerCase();
      }
      if (this.userAnswer === answerCorrect) {
        questionType === 'M'
          ? (this.test.average += 9.75)
          : null || questionType === 'B'
          ? (this.test.average += 9.5)
          : null || questionType === 'T'
          ? (this.test.average += 10)
          : null;

        this.test.questionsCorrect++;
      } else {
        this.test.wrongQuestions++;
      }
      this.nextQuestion();
    },
    nextQuestion() {
      const question = this.questions[this.selectedQuestionIndex];
      //this.test.questions.push({ ...question, user_answer: this.userAnswer });
      this.test.questions.push({
        ...question,
        user_answer: this.userAnswer,
        skipped_question: this.skipped,
      });
      this.skipped = false; //
      if (this.selectedQuestionIndex < this.questions.length - 1) {
        this.renderQuestion = false;
        this.selectedQuestionIndex++;
        this.userAnswer = null;

        this.timePerQuestion = this.secondsPerQuestion ? this.secondsPerQuestion : 45;
        this.countDownTimer();
        setTimeout(() => {
          this.renderQuestion = true;
        }, 100);
        return;
      }
      this.testFinished();
    },
    fetchQuestions() {
      this.loading = true;
      this.$httpMain
        .post(`questions/cluster`, {
          cluster_id: Number.parseInt(this.$route.params.cluster_id),
          per_page: 10,
          subject_id: Number.parseInt(this.$route.params.subject_id),
          user_id: Number.parseInt(this.authenticatedUser.id),
        })
        .then(res => {
          this.questions = res.data.questions;
          this.secondsPerQuestion = res.data.seconds_per_question ? res.data.seconds_per_question : 45;
          this.timePerQuestion = this.secondsPerQuestion;
          // console.log(this.secondsPerQuestion);
          this.countDownTimer();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    testFinished() {
      if (this.questions.length === 7) {
        this.test.average = Math.floor((this.test.questionsCorrect * 100) / 7);
      }
      if (this.questions.length === 10 && this.test.correctAnswers === 7) {
        this.test.average = 70;
      }
      if (this.questions.length === this.test.questionsCorrect) {
        this.test.average = 100;
      }
      this.test.finishDate = moment().format();
      this.saveResult();
    },
    saveResult() {
      this.$httpMain
        .post(`test`, {
          correct_answers: this.test.questionsCorrect,
          incorrect_answers: this.test.wrongQuestions,
          average: this.test.average,
          started_date: this.test.startedDate,
          finish_date: this.test.finishDate,
          cluster_id: this.test.clusterId,
          user_id: this.authenticatedUser.id,
        })
        .then(res => {
          this.$router.push({ name: 'testResults', params: { test_id: res.data } });
          localStorage.setItem(`test_${res.data}`, JSON.stringify(this.test));
        });
      if (this.test.average >= 70) {
        // Desbloquea el siguiente cluster
      }
    },
    skipQuestion() {
      this.skipped = true; //saber si la pregunta fue saltada
      this.test.skippedQuestions++;
      this.nextQuestion();
    },
  },
};
</script>

<style lang="sass" scoped>
.test
  display: flex
  justify-content: center
  align-items: center
  flex-direction: column
  padding-bottom: 1em
  padding-top: 2em
  +forTablet
    padding-top: 1em
  +forDesktop
    min-height: 70vh
  +element('container')
    position: relative
    overflow-y: auto
    box-shadow: 5px 5px 10px rgba(0,0,0,.5)
    border-radius: 30px
    background-color: #fff
    width: 100%
    +forTablet
      margin-top: .5em
      width: 98%
    +forDesktop
      margin-top: unset
      width: 850px
      height: 600px
  +element('progress')
    text-align: center
    font-weight: 600
    width: 100%
    height: 100%
    display: flex
    justify-content: center
    height: 35px
    margin-bottom: 1em
    +forTablet
      margin-bottom: unset
    +forDesktop
      margin-bottom: 1em
    // span:last-child
    //   display: none
    // li:nth-child(2)
    //   display: none
  +element('progress-item')
    background-color: rgba($color: #add8e6, $alpha: 0.6)
    display: inline-block
    position: relative
    margin-right: 0.5rem
    border-radius: 50%
    color: #ff6d00
    height: 1.8em
    line-height: 1.8em
    text-align: center
    width: 1.8em
    z-index: 20
    font-size: 14px
    +forDesktop
      height: 2em
      width: 2em
      line-height: 2em
      font-size: 16px
    +modifier('active')
      background-color: #00b9ff
      color: #ffffff

  // .progress-indicators .progressline {
  //   height: 0.4rem;
  //   width: 3rem;
  //   margin: 1px -5.5px;
  //   z-index: 10;

.question
  +element('info')
    background-color: #00b9ff
    border-top-left-radius: 30px
    border-top-right-radius: 30px
    text-align: center
    padding: 1em
    color: #fff
    position: relative
    +forDesktop
      display: block
      align-items: unset
      justify-content: unset
  +element('info-time')
    +forTablet
      position: absolute
      right: 1em
      top: calc( 50% - 8px )
  +element('info-text')
    font-size: 18px
    margin-bottom: .5em
    +forTablet
      margin-bottom: 0
  +element('text')
    font-size: 14px
    font-weight: 600
    text-align: center
    margin-bottom: 1em
  +element('example')
    font-size: 16px
    font-weight: 400
    text-align: center
    margin-bottom: .5em
  +element('multiple-choices')
    +forTabletLandscape
      margin-top: 1em
      columns: 2
      -webkit-columns: 2
      -moz-columns: 2
    +forDesktop
      columns: unset
  +element('multiple-choices-item')
    font-size: 12px
    background-color: #dfe9f0
    border-radius: 5px
    font-family: comfortaabold
    text-transform: uppercase
    display: flex
    justify-content: center
    align-items: center
    min-height: 4em
    margin-bottom: .5em
    margin-top: .5em
    +forTablet
      margin-bottom: .5em
      margin-top: 0
    +forDesktop
      margin-bottom: 1em
  +element('multiple-choices-item-button')
    min-height: 4em
    width: 100%
    height: 100%
    &:focus
      background-color: #ff6d00
      outline: none
      box-shadow: none
    +modifier('active')
      background-color: #ff6d00
      color: #fff
  +element('two-choices')
    margin-top: 2em
    columns: 2
    -webkit-columns: 2
    -moz-columns: 2
  +element('two-choices-item')
    font-size: 12px
    background-color: #dfe9f0
    border-radius: 5px
    font-family: comfortaabold
    text-transform: uppercase
    display: flex
    justify-content: center
    align-items: center
    min-height: 4em
    margin-bottom: .5em
    margin-top: .5em
    +forTablet
      margin-bottom: .5em
      margin-top: 0
    +forDesktop
      margin-bottom: 1em
  +element('two-choices-item-button')
    min-height: 4em
    width: 100%
    height: 100%
    &:focus
      background-color: #ff6d00
      outline: none
      box-shadow: none
    +modifier('active')
      background-color: #ff6d00
      color: #fff
  +element('write-answer')
    margin-top: 2em
    margin-bottom: 2em
  +element('write-answer-input')
    width: 250px
    margin: auto
  +element('actions')
    display: flex
    justify-content: space-around
    margin-bottom: 1em
    +forTablet
    +forDesktop
      position: absolute
      bottom: 1em
      left: 0
      right: 0
.btn-skip,
.btn-submit
  justify-self: center
  color: #ffffff
  padding: 5px
  font-family: 'comfortaabold'
  font-weight: bold
  font-size: 18px
  width: 130px
  height: 35px
.btn-skip
  background-color: #ff6d00
  &:focus
    box-shadow: 0 0 0 3px rgba($color: #ff6d00, $alpha: 0.5)
.btn-submit
  background-color: #7ac35c
  &:disabled
    background-color: #a0a0a0 !important
  &:focus
    box-shadow: 0 0 0 3px rgba($color: #7ac35c, $alpha: 0.5)
.btn-exit
  position: fixed
  bottom: 0
  left: 0
  color: #ffffff
  background-color: #ff1800
  border-bottom-left-radius: 0
  border-top-left-radius: 0
  font-family: 'comfortaabold'
  font-weight: bold
  font-size: 18px
  display: flex
  align-items: center
  img
    margin-right: 10px
    width: 18px
  &:hover
    transform: none
  &:focus
    box-shadow: 0 0 0 3px rgba($color: #ff1800, $alpha: 0.5)
</style>
